module.exports = __webpack_public_path__ + "static/media/image7.a533e93b.jpg";